/* Pages Judge.me's review cards three at a time.

   The layout override lives in CSS (author !important beats their inline
   styles); this only drives the offset and the arrow states. Judge.me mounts
   asynchronously and re-renders on sort and filter, so the card list is
   re-read on every observed mutation. */
(() => {
  const init = (root) => {
    if (root.dataset.frReady) return;

    const nav = root.querySelector('[data-fr-nav]');
    const prev = root.querySelector('[data-fr-prev]');
    const next = root.querySelector('[data-fr-next]');
    const count = root.querySelector('[data-fr-count]');
    if (!nav || !prev || !next) return;

    let page = 0;
    let writing = false;
    let frame = 0;

    const perView = () => {
      const raw = parseInt(getComputedStyle(root).getPropertyValue('--fr-per'), 10);
      return Number.isFinite(raw) && raw > 0 ? raw : 1;
    };

    const items = () =>
      Array.from(root.querySelectorAll('.jdgm-masonry-grid__masonry-item'));

    const render = () => {
      writing = true;
      const cards = items();
      const per = perView();
      const pages = Math.max(1, Math.ceil(cards.length / per));

      page = Math.min(page, pages - 1);
      nav.hidden = cards.length <= per;

      if (nav.hidden) {
        root.style.setProperty('--fr-x', '0px');
        writing = false;
        return;
      }

      const first = cards[0];
      const track = first.parentElement;
      // Card width plus the flex gap; both come from the stylesheet.
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const step = (first.getBoundingClientRect().width + gap) * per;

      root.style.setProperty('--fr-x', `${-page * step}px`);
      prev.disabled = page === 0;
      next.disabled = page >= pages - 1;
      if (count) count.textContent = `${page + 1} / ${pages}`;
      writing = false;
    };

    /* render() writes inside root, which the observer below would see as a new
       mutation, so our own writes are ignored and the rest is coalesced. */
    const schedule = () => {
      if (writing) return;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(render);
    };

    prev.addEventListener('click', () => {
      page = Math.max(0, page - 1);
      render();
    });

    next.addEventListener('click', () => {
      page += 1;
      render();
    });

    window.addEventListener('resize', () => {
      page = 0;
      schedule();
    });

    // Their widget mounts after this script runs and rebuilds on sort/filter.
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });

    root.dataset.frReady = 'true';
    render();
  };

  document.querySelectorAll('[data-flavor-reviews]').forEach(init);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-flavor-reviews]').forEach(init);
  });
})();
